import React, { useEffect, useState } from "react";

const MetricsSkeleton: React.FC = () => {
  const [width, setWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <section className="section relative text-white py-10 max-sm:py-6 z-[1] blue-bg-dots overflow-hidden">
        <div className="container mx-auto">
          <h2 className="text-[#91DBE7] text-6xl max-md:text-4xl max-sm:text-3xl text-start mb-8 max-sm:mb-6 break-all">
            <div className="h-14 max-sm:h-8 max-sm:w-full w-96 max-md:w-56 bg-gray-300 skeleton rounded"></div>
          </h2>

          <div className="mb-10 flex flex-col">
            {width < 768 ? (
              <>
                <div className="flex items-center justify-center gap-5 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="max-md:h-[170px] max-md:w-[170px] max-sm:h-[120px] max-sm:w-[120px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
                <div className="flex items-center justify-center gap-5 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="max-md:h-[170px] max-md:w-[170px] max-sm:h-[120px] max-sm:w-[120px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
                <div className="flex items-center justify-center gap-5 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="max-md:h-[170px] max-md:w-[170px] max-sm:h-[120px] max-sm:w-[120px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
                <div className="flex items-center justify-center gap-5 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="max-md:h-[170px] max-md:w-[170px] max-sm:h-[120px] max-sm:w-[120px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
              </>
            ) : width < 1024 ? (
              <>
                <div className="flex items-center justify-center gap-7 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[200px] w-[200px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
                <div className="flex items-center justify-center gap-7 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[200px] w-[200px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
                <div className="flex items-center justify-center gap-7 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[200px] w-[200px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
              </>
            ) : width < 1280 ? (
              <>
                <div className="flex items-center justify-center gap-5 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[210px] w-[210px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
                <div className="flex items-center justify-center gap-5 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[210px] w-[210px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
                <div className="flex items-center justify-center gap-5 flex-wrap my-2">
                  {[1, 2, 3].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[210px] w-[210px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
              </>
            ) : width < 1536 ? (
              <>
                <div className="flex items-center justify-center gap-5 flex-wrap">
                  {[1, 2, 3, 4, 5, 6].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[180px] w-[180px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
                <div className="flex items-center justify-center gap-5 flex-wrap">
                  {[1, 2, 3, 4, 5].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[200px] w-[200px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center justify-center gap-14 flex-wrap">
                  {[1, 2, 3, 4, 5, 6].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[200px] w-[200px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
                <div className="flex items-center justify-center gap-14 flex-wrap">
                  {[1, 2, 3, 4, 5].map((item) => {
                    return (
                      <div
                        key={item}
                        className="h-[200px] w-[200px] bg-gray-300 skeleton !rounded-full"
                      ></div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};
export default MetricsSkeleton;
